module.exports = __webpack_public_path__ + "img/per4media.cc074e57.png";